/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
    'use strict';

    /**
     * Форма обращение к менеджеру
     */
    app.PartHelpPopupForm = app.Model.extend({

        urlRoot: app.entryScriptName + '/api/v3/message-to-parts-manager',

        defaults: {
            name: '',
            email: '',
            phone: '',
            brand: '',
            parts: [''],
            vin: ''
        },
    });
})();

}.call(window));